import { inject, Inject, Injectable } from '@angular/core'
import { BootstrapData, License } from 'elements-sdk'
import { BOOTSTRAP_DATA } from 'api/providers'
import { CanActivateFn } from '@angular/router'

@Injectable({ providedIn: 'root' })
export class LicenseService {
  constructor (
    @Inject(BOOTSTRAP_DATA) private bootstrapData: BootstrapData,
  ) { }

  getLicense (): License {
    return this.bootstrapData.license
  }

  hasComponent (component: string): boolean {
    return !!this.bootstrapData.license.components[component]
  }
}

export function licenseGuard (component: string): CanActivateFn {
  return () => inject(LicenseService).hasComponent(component)
}
